import { PlusIcon, Trash2 } from "lucide-react";
import { useFieldArray, useFormContext } from "react-hook-form";

import InputField from "@/components/reusables/custom-form-fields/InputField";
import { Button } from "@/components/ui/button";
import { FormField } from "@/components/ui/form";
import { IProject } from "@/interfaces/project.interface";
import { useDeleteProjectInductionMutation } from "@/redux/api/projectsQuery";
import { TAddProjectSchema } from "@/schemas/project.schema";

const ProjectRes = ({
  action = "add",
  data,
}: {
  action?: string;
  data?: IProject;
}): React.ReactElement => {
  const { control, register } = useFormContext<TAddProjectSchema>();

  const [deleteInduction, { isLoading: isDeleting }] =
    useDeleteProjectInductionMutation();

  const { fields, remove, append } = useFieldArray({
    control,
    name: "inductions",
    keyName: "idx",
  });

  const handleDeleteInduction = async (index: number): Promise<void> => {
    if (action === "update") {
      const induction = fields?.at(index)?.id;

      if (induction && (data as IProject)?.id) {
        await deleteInduction({
          induction_id: induction,
          project_id: (data as IProject)?.id,
        });
      }
    }
    remove(index);
  };

  return (
    <>
      <h2 className='col-span-3 text-lg font-medium'>Induction</h2>
      {fields?.map((field, index) => (
        <div
          key={field.idx}
          className='flex items-end w-full col-span-3 gap-4 p-4 border rounded-md'
        >
          <FormField
            control={control}
            name={`inductions.${index}.name`}
            render={({ field }) => (
              <InputField
                {...field}
                className='w-full'
                label={`${index + 1}.${" "}Induction Name`}
                register={register(`inductions.${index}.name`)}
                placeholder='Please Enter Induction Name'
              />
            )}
          />

          <FormField
            control={control}
            name={`inductions.${index}.value`}
            render={({ field }) => (
              <InputField
                {...field}
                label='Induction URL'
                className='w-full'
                register={register(`inductions.${index}.value`)}
                placeholder='Please Enter Induction URL'
              />
            )}
          />
          {/* {(fields.length > 1 || index !== 0) && ( */}
          <Button
            className='w-fit'
            type='button'
            variant={"ghost"}
            isLoading={isDeleting}
            onClick={() => handleDeleteInduction(index)}
          >
            <Trash2 size={20} color='red' />
          </Button>
          {/* )} */}
        </div>
      ))}
      <Button
        className='w-[200px] py-6 border-primary text-primary'
        variant={"outline"}
        type='button'
        onClick={() =>
          append({
            name: "",
            value: "",
          })
        }
      >
        <PlusIcon size={25} /> Add New Induction
      </Button>
    </>
  );
};

export default ProjectRes;
